import { computed, onBeforeUnmount, onMounted, ref } from "vue";

export default function useViewport () {
  const viewport = ref({
    width: 1440,
    height: 900,
  });

  onMounted(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", handleResize);
  });

  const isTablet = computed(() => viewport.value.width > 600 && viewport.value.width <= 1100);

  function handleResize () {
    viewport.value.width = window.innerWidth;
    viewport.value.height = window.innerHeight;
  }

  return {
    viewport,
    isTablet,
  };
}
